<template>
  <Modal
      v-if="pokedexPokemonContent !== undefined"
      :is-open="isOpen"
      :closeable="false"
  >
    <h3>
      {{ pokedexPokemonContent.name }} #{{ pokedexPokemonContent.pokedex_id }}
    </h3>

    {{ pokedexPokemonContent.description }}
    <br/>
    <div class="pokeinfo-header__type">
      <div :class="'pokeinfo-header__type--' + pokedexPokemonContent.type1">
        <div></div>
      </div>
      <div :class="'pokeinfo-header__type--' + pokedexPokemonContent.type2">
        <div></div>
      </div>
    </div>

    <br/>
    {{ translation.pokemonList.weight }}: {{ pokedexPokemonContent.weight }} KG
    <br/>
    {{ translation.pokemonList.generation }}:
    {{ pokedexPokemonContent.generation }}
    <br/>
    Tier: {{ pokedexPokemonContent.tier }}

    <br/>
    <br/>

    <h4>
      {{ translation.pokemonList.base_stats }}
    </h4>

    <div class="base-stats">
      <div class="base-stats-name">
        {{ translation.pokemonList.hp }}: <br/>
      </div>
      <div class="base-stats-number">
        {{ pokedexPokemonContent.base_stats.hp }}
      </div>
      <div
          class="base-stats-bar"
          :style="getBarWidth(pokedexPokemonContent.base_stats.hp)"
      ></div>
    </div>

    <div class="base-stats">
      <div class="base-stats-name">
        {{ translation.pokemonList.attack }}: <br/>
      </div>
      <div class="base-stats-number">
        {{ pokedexPokemonContent.base_stats.attack }}
      </div>
      <div
          class="base-stats-bar"
          :style="getBarWidth(pokedexPokemonContent.base_stats.attack)"
      ></div>
    </div>

    <div class="base-stats">
      <div class="base-stats-name">
        {{ translation.pokemonList.specialAttack }}: <br/>
      </div>
      <div class="base-stats-number">
        {{ pokedexPokemonContent.base_stats.special_attack }}
      </div>
      <div
          class="base-stats-bar"
          :style="getBarWidth(pokedexPokemonContent.base_stats.special_attack)"
      ></div>
    </div>

    <div class="base-stats">
      <div class="base-stats-name">
        {{ translation.pokemonList.defense }}: <br/>
      </div>
      <div class="base-stats-number">
        {{ pokedexPokemonContent.base_stats.defense }}
      </div>
      <div
          class="base-stats-bar"
          :style="getBarWidth(pokedexPokemonContent.base_stats.defense)"
      ></div>
    </div>

    <div class="base-stats">
      <div class="base-stats-name">
        {{ translation.pokemonList.specialDefense }}: <br/>
      </div>
      <div class="base-stats-number">
        {{ pokedexPokemonContent.base_stats.special_defense }}
      </div>
      <div
          class="base-stats-bar"
          :style="getBarWidth(pokedexPokemonContent.base_stats.special_defense)"
      ></div>
    </div>

    <div class="base-stats">
      <div class="base-stats-name">
        {{ translation.pokemonList.speed }}: <br/>
      </div>
      <div class="base-stats-number">
        {{ pokedexPokemonContent.base_stats.speed }}
      </div>
      <div
          class="base-stats-bar"
          :style="getBarWidth(pokedexPokemonContent.base_stats.speed)"
      ></div>
    </div>

    <div class="base-stats">
      <div class="base-stats-name">
        {{ translation.pokemonList.total }}: <br/>
      </div>
      <div class="base-stats-number">
        {{
          pokedexPokemonContent.base_stats.hp +
          pokedexPokemonContent.base_stats.attack +
          pokedexPokemonContent.base_stats.special_attack +
          pokedexPokemonContent.base_stats.special_defense +
          pokedexPokemonContent.base_stats.defense +
          pokedexPokemonContent.base_stats.speed
        }}
      </div>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="
          pokedexPokemonContent = undefined;
          $emit('update:isOpen', false);
        "
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../Modal/Modal.vue";
import {translation} from "@/utils/translations";
import {ref, watch} from "vue";
import {
  startLoadingProcess,
  stopLoadingProcess,
} from "@/components/LoadingOverlay/loadingOverlayControl";
import {handleUnknownError} from "@/utils/utilities";
import {PCGApi} from "../../services/pcg";

export default {
  components: {
    Modal,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    pokemonId: {
      type: Number,
      default: 0,
    },
  },
  emits: ["update:isOpen"],
  methods: {
    getBarWidth(stat) {
      let width = stat;
      if (width > 160) {
        width = 160;
      }
      width = width / 2.75;

      let color = "";
      if (stat > 130) {
        color = "#5cbcf5";
      } else if (stat > 85) {
        color = "#6ada46";
      } else if (stat > 50) {
        color = "#ffdc33";
      } else if (stat > 25) {
        color = "#da6127";
      } else {
        color = "#a21c1c";
      }

      return {
        width: width + "%",
        backgroundColor: color,
      };
    },
  },
  setup(props) {
    const pokedexPokemonContent = ref(undefined);
    const getPokedexInformation = async () => {
      console.debug(`Obtaining pokédex info for id: ${props.pokemonId}`);
      startLoadingProcess();

      try {
        const response = await PCGApi.Trainer.getPokedexInfo(props.pokemonId);
        pokedexPokemonContent.value = response.data.content;
      } catch (err) {
        handleUnknownError(err);
      }

      stopLoadingProcess();
    };

    watch(
        () => props.isOpen,
        (newValue) => {
          if (newValue) {
            getPokedexInformation();
          }
        }
    );

    return {
      translation,

      pokedexPokemonContent,
    };
  },
};
</script>

<style scoped lang="scss">
.base-stats {
  display: flex;
  border-bottom: 1px solid rgba(155, 155, 155, 0.2);
  padding: 2px;

  &-name {
    width: 31%;
  }

  &-number {
    width: 10%;
  }

  &-bar {
    border-radius: 25px;
    height: 15px;
    margin-top: auto;
    margin-bottom: auto;
    box-shadow: black 0 0 0 2px;
  }
}

.pokeinfo-header {
  border-bottom: 1px solid #dee2e6;
  padding: 36px 16px 16px;

  &__sprite {
    position: absolute;
    width: 100%;
    left: 0;
    height: 150px;
    background-repeat: no-repeat;
    background-position: center;
    top: 30px;
    image-rendering: pixelated;
  }

  &__id {
    position: absolute;
    top: 25px;
    transform: rotate(-10deg);
    left: 25px;
    color: #c5c5c5;
  }

  &__name {
    margin-top: 8px;
  }

  &__type {
    position: absolute;
    width: 35px;
    right: 20px;
    top: 144px;

    & > div {
      height: 35px;
      border-radius: 100px;
      margin-bottom: 5px;
    }

    div > div {
      height: 100%;
      width: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 65%;
      content: "";
    }

    &--ice {
      background: #76d1c1;
      box-shadow: #76d1c1 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/ice.svg");
      }
    }

    &--dark {
      background: #212121;
      box-shadow: #212121 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/dark.svg");
      }
    }

    &--fairy {
      background: #ef90e6;
      box-shadow: #ef90e6 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/fairy.svg");
      }
    }

    &--dragon {
      background: #0c6ac8;
      box-shadow: #0c6ac8 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/dragon.svg");
      }
    }

    &--psychic {
      background: #fa8582;
      box-shadow: #fa8582 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/psychic.svg");
      }
    }

    &--electric {
      background: #f2d94e;
      box-shadow: #f2d94e 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/electric.svg");
      }
    }

    &--grass {
      background: #60bd58;
      box-shadow: #60bd58 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/grass.svg");
      }
    }

    &--water {
      background: #539ddf;
      box-shadow: #539ddf 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/water.svg");
      }
    }

    &--fire {
      background: #fba64c;
      box-shadow: #fba64c 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/fire.svg");
      }
    }

    &--steel {
      background: #5795a3;
      box-shadow: #5795a3 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/steel.svg");
      }
    }

    &--ghost {
      background: #5f6dbc;
      box-shadow: #5f6dbc 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/ghost.svg");
      }
    }

    &--bug {
      background: #92bd2d;
      box-shadow: #92bd2d 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/bug.svg");
      }
    }

    &--rock {
      background: #c9bc8a;
      box-shadow: #c9bc8a 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/rock.svg");
      }
    }

    &--ground {
      background: #da7c4d;
      box-shadow: #da7c4d 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/ground.svg");
      }
    }

    &--poison {
      background: #b763cf;
      box-shadow: #b763cf 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/poison.svg");
      }
    }

    &--flying {
      background: #a1bbec;
      box-shadow: #a1bbec 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/flying.svg");
      }
    }

    &--fighting {
      background: #d3425f;
      box-shadow: #d3425f 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/fighting.svg");
      }
    }

    &--normal {
      background: #a0a29f;
      box-shadow: #a0a29f 0 0 5px;

      div {
        background-image: url("~@/assets/img/type-icons-white/normal.svg");
      }
    }
  }
}
</style>
